import { createStyles, IconButton, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

import { useInternalChatContext } from 'src/features/assistant/internalChatContext';
import { EditIcon, TrashIcon } from 'src/legacy/components/Icons';
import { DividersAndCardBorders, NonHoverBorder, red } from 'src/theme/colors';
import { RegularCardShadow } from 'src/theme/shadows';

interface StylingProps {
  isInternalChat: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: '36px',
      display: 'flex',
      alignItems: 'center',
      position: 'absolute',
      right: ({ isInternalChat }: StylingProps) =>
        isInternalChat ? '0px' : '112px',
      top: -theme.spacing(1.5),
      border: `1px solid ${NonHoverBorder}`,
      backgroundColor: '#fff',
      boxShadow: RegularCardShadow,
      borderRadius: theme.shape.borderRadius,
      // adding vertical separator between the buttons
      '& > button:first-of-type': {
        borderTopRightRadius: '0',
        borderBottomRightRadius: '0',
        borderRight: `1px solid ${DividersAndCardBorders}`,
      },
    },
  }),
);

interface MessageActionsMenuProps {
  onDeleteClicked: () => void;
  onEditClicked: (ev: React.MouseEvent<HTMLElement>) => void;
}
export const MessageActionsMenu: React.FC<MessageActionsMenuProps> = ({
  onDeleteClicked,
  onEditClicked,
}) => {
  const { isInternalChat } = useInternalChatContext();
  const classes = useStyles({ isInternalChat });
  const messageActions = React.useMemo(
    () => [
      {
        id: 'edit-message-action',
        Icon: EditIcon,
        onClick: onEditClicked,
      },
      {
        id: 'delete-message-action',
        Icon: TrashIcon,
        onClick: onDeleteClicked,
        isDelete: true,
      },
    ],
    [onDeleteClicked, onEditClicked],
  );

  return (
    <div className={`${classes.root} messageActionsMenu z-10`}>
      {messageActions.map(({ id, Icon, onClick, isDelete }) => (
        <IconButton key={id} onClick={onClick}>
          <Icon
            style={{
              fontSize: 12,
              color: isDelete ? red : 'inherit',
            }}
          />
        </IconButton>
      ))}
    </div>
  );
};
